import { render } from "./ClientRelease.vue?vue&type=template&id=72cd2ab5&scoped=true"
import script from "./ClientRelease.vue?vue&type=script&lang=js"
export * from "./ClientRelease.vue?vue&type=script&lang=js"

import "./ClientRelease.vue?vue&type=style&index=0&id=72cd2ab5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72cd2ab5"]])

export default __exports__